import { getProductStatusByID } from "@/helpers/generalHelper";
import Carousel from "./CommonCarouselComponent";
import { getProductTag } from "@/helpers/productHelper";
import { getNumberId } from "@/helpers/wishlistHelpers";
import { useEffect, useState } from "react";
import { reportError } from "@/helpers/errorHelper";

const ProductCarousel = (props) => {
  const [componentTag, setComponentTag] = useState('');
  const generateProductArr = async (products) => {
    const tempArr = await Promise.all(products.map(async (obj) => {
      var temp = obj?.product?.data;
      if (temp && temp?.id) {
          try {
            let resp = await getProductTag(getNumberId(temp.id)); //7027770130511,7027633258575
            if (resp && !resp.error) {
              temp.named_tags = resp.named_tags
              obj.product.data = temp
              return obj;
            }
          } catch (error) {
            reportError("Error in Product Carousel")
            reportError(error)
          }
        }
    }));
    
    const results = tempArr.filter(element => { return element !== undefined;}); // remove undefined elements from array
    setComponentTag(<Carousel
      desktopSlidesToShow={4.7}
      desktopSlidesToScroll={4}
      tabletSlidesToShow={4.3}
      tabletSlidesToScroll={4}
      mobileSlidesToShow={2.2}
      mobileSlidesToScroll={2}
      carouselClass={"product-slider-wrapper"}
      productsList={results}
      isProductCarousel={true}
      {...props}
    />) 
  };

  useEffect(()=>{
    // we loop through each product and fetch the product tags because we do
    // don't recieve tags from builder data
    generateProductArr(props.product);
  },[])

  return (
    componentTag
  );
};

export default ProductCarousel;
